import {ReactElement, useState} from 'react';
import Icon from '../../atoms/Icon/Icon';
import StyledAccordion, {StyledAccordionBody, StyledAccordionHeader} from './styles';
import Props from './typings';

const Accordion = ({
  title,
  subtitle,
  defaultCollapsed = true,
  hasDividers = false,
  collapsible = true,
  strongTitle = true,
  className,
  children,
}: Props): ReactElement => {
  const [open, setOpen] = useState(!defaultCollapsed);

  const onClick = () => {
    if (collapsible) setOpen(!open);
  };

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // Prevent scrolling on space
      onClick();
    }
  };

  return (
    <StyledAccordion $hasDividers={hasDividers} className={className}>
      <StyledAccordionHeader
        onClick={onClick}
        onKeyDown={onKeyDown}
        tabIndex={0}
        $collapsible={collapsible}
        $strongTitle={strongTitle}
      >
        {typeof title === 'string' ? <h4>{title}</h4> : title}

        {subtitle && <p>{subtitle}</p>}

        {collapsible && <Icon type={open === true ? 'minus' : 'plus'} />}
      </StyledAccordionHeader>

      <StyledAccordionBody $open={open}>{children}</StyledAccordionBody>
    </StyledAccordion>
  );
};

export default Accordion;
